import "./ThirdItem.css"

export default function ThirdItem() {
  return (
      <div className="thirdItem">
        <h3>Core Values</h3>
        <hr/>
        <div className="thirdItem-mainBox">
            <div className="thirdItem-box">
                <img src="http://www.globaltimes.cn/Portals/0/attachment/2016/2016-06-30/085a2501-5ec5-43dd-9074-26fc4a0371be.jpeg" alt="" />
                <div className="thirdItem-box-text">Mutual Respect</div>
            </div>
            <div className="thirdItem-box">
                <img src="https://image.flaticon.com/icons/png/512/912/912278.png" alt="" />
                <div className="thirdItem-box-text">Innovation</div>
            </div>
            <div className="thirdItem-box">
                <img src="https://www.clipartkey.com/mpngs/m/42-427617_ethics-png.png" alt="" />
                <div className="thirdItem-box-text">Integrity</div>
            </div>
            <div className="thirdItem-box">
                <img src="https://static.thenounproject.com/png/391685-200.png" alt="" />
                <div className="thirdItem-box-text">Professionalism</div>
            </div>
            <div className="thirdItem-box">
                <img src="https://www.vippng.com/png/detail/101-1012399_flexibility-flexibility-icon-png.png" alt="" />
                <div className="thirdItem-box-text">Flexibility</div>
            </div>
            <div className="thirdItem-box">
                <img src="http://www.atlantic-bone-screen.com/wp-content/uploads/2016/10/responsiveness.png" alt="" />
                <div className="thirdItem-box-text">Responsiveness</div>
            </div>
        </div>
      </div>
  )
}